import React, { useEffect, useRef } from 'react';
import {
  useTrackBlockImpression,
  useTrackBlockClicked,
} from '../../hooks/tracking/useTrackingEvents';

interface ISliceTracking {
  children: React.ReactNode;
  blockType: string;
  order: number;
}

const SliceTracking = ({ blockType, children, order }: ISliceTracking) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const trackBlockImpression = useTrackBlockImpression();
  const trackBlockClicked = useTrackBlockClicked();

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      let node = e.target as HTMLElement;
      let anchorNode = null;

      while (anchorNode === null && node != wrapperRef.current && node != null) {
        if (node?.nodeName.toLowerCase() === 'a') {
          anchorNode = node as HTMLAnchorElement;
        }
        node = node.parentNode as HTMLElement;
      }

      if (anchorNode !== null && wrapperRef.current) {
        trackBlockClicked(blockType.replace('slices/', ''), order, anchorNode.href);
        wrapperRef.current.removeEventListener('click', onClick);
      }
    };

    const onIntersect = (entries: IntersectionObserverEntry[]) => {
      const intersectingEntries = entries.find((entry) => {
        return entry.isIntersecting;
      });

      if (intersectingEntries && wrapperRef.current) {
        trackBlockImpression(blockType.replace('slices/', ''), order);
        observer.unobserve(wrapperRef.current);

        wrapperRef.current.addEventListener('click', onClick);
      }
    };

    const observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }

    return () => {
      if (wrapperRef.current) {
        observer.unobserve(wrapperRef.current);
        wrapperRef.current.addEventListener('click', onClick);
      }
    };
  }, []);

  return <div ref={wrapperRef}>{children}</div>;
};

export default SliceTracking;
